var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.839,
    height: 14.838,
    viewBox: "0 0 19.839 14.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(-0.75 -5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M1.5,12.669S4.834,6,10.67,6s9.17,6.669,9.17,6.669-3.334,6.669-9.17,6.669S1.5,12.669,1.5,12.669Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#30346b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    d: "M18.5,16A2.5,2.5,0,1,1,16,13.5,2.5,2.5,0,0,1,18.5,16Z",
    transform: "translate(-5.331 -3.332)",
    fill: "none",
    stroke: "#30346b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.b7b060ae5429961f8e3377b459721d00.svg";
export { ForwardRef as ReactComponent };